import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const SKILL: ObjectTypeConfig = {
  actions: [
    {
      id: "star",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.isFavorite,
    },
    {
      id: "unstar",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: { not: predicates.isFavorite },
    },
    {
      id: "edit",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    // Auto/Manual is a single toggle rendered as whichever mode you'd switch to.
    {
      id: "set-manual",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: { not: predicates.isSkillEnabled },
    },
    {
      id: "set-auto",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.isSkillEnabled,
    },
    {
      id: "publish",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    // Download the skill's files as a zip. Handler-gated: only the skill detail
    // pane wires a download handler, so it surfaces there; rail rows (which
    // don't) never show it. Sits in the `file` group → renders between Publish
    // (sharing) and Move to Trash (destructive).
    {
      id: "download",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "delete",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
  ],
};
